import { action } from 'mobx';
import { BooleanStore } from 'ui/base/input';
import { IPangolinDomain, Schedule } from 'services/pangolin/types';
import { ScheduleUpdateResult, SchedulesService } from 'services/pangolin/schedule_service';

export class ScheduleDisplayStore {
  readonly enabled: BooleanStore;
  readonly schedule: Schedule;

  constructor(schedule: Schedule) {
    this.schedule = schedule;
    this.enabled = new BooleanStore(schedule.enabled);
  }

  @action.bound
  handleToggle(domain: IPangolinDomain): Promise<ScheduleUpdateResult> {
    return SchedulesService.update(domain, {
      uuid: this.schedule.uuid,
      enabled: this.enabled.value,
    });
  }
}
